module.exports = __webpack_public_path__ + "static/avatar-170bb5e564acff72ffcea578aa131bdd.jpg";